var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rotating-card",class:_vm.flipped ? 'flipped' : ''},[_c('div',{staticClass:"card-panel face"},[_vm._t("face")],2),_vm._v(" "),_c('div',{staticClass:"back card-panel indigo lighten-1 white-text"},[_c('i',{staticClass:"icon ion-close",on:{"click":function($event){_vm.$emit('closeCard')}}}),_vm._v(" "),_vm._t("back")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee598ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/rotatingCard.vue
// module id = null
// module chunks = 